<template>
	<v-layout row wrap>
		<v-flex sm12 md6>
			<p class="mr-4 mt-5 add-event-step-header-big">Adding Events &amp; Experiences</p>
			<p class="add-event-step-content">Whether you’re adding a new WRKPRTY (coworking event), WRKSHOP, or another type of experience, we’re excited to see what you will create - and to assist any way we can!</p>
			<p class="add-event-step-content">Please keep in mind all events &amp; experiences posted on the WRKPRTY platform should be <strong>in-person</strong> and support <strong>networking &amp; social connection</strong> (real high-fives are always encouraged!). Also, all events should have an <strong>underlying work, professional development, productivity</strong> focus.</p>
			<p class="add-event-step-content">Well, that’s plenty of blah, blah, blah for now ... Let’s do this!</p>
		</v-flex>
		<v-flex xs12 md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-tip-title">Need help?</p>
					<p class="add-event-tip-content">That’s what we’re here for!</p>
					<p class="add-event-tip-content">Please don’t hesitate to contact us for assistance or questions.</p>
					<p class="text-xs-center add-event-tip-content"><strong>support@wrkprty.com</strong></p>
					<p class="text-xs-center"><a href="tel:209-975-7789"><i class="fa fa-phone"></i>&nbsp;(209) 975-7789</a></p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-title">Need help?</p>
					<p class="add-event-tip-content">That’s what we’re here for!</p>
					<p class="add-event-tip-content">Please don’t hesitate to contact us for assistance or questions.</p>
					<p class="text-xs-center add-event-tip-content"><strong>support@wrkprty.com</strong></p>
					<p><a href="tel:209-975-7789"><i class="fa fa-phone"></i>&nbsp;(209) 975-7789</a></p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
	name: 'event-start',
	methods: {
		...mapActions(['setAddEventValidStep', 'setModalOpen', 'setAddEventProp'])
	},
	beforeRouteLeave(to, from, next) {
		this.setAddEventValidStep(from.path)
		next()
	},
	computed: {
		...mapGetters(['getAddEventProp']),
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style>
</style>
